export default __webpack_public_path__ + "static/0040-3dae4e4a852131e8d040f82ad4f096cd.png";